import { useCallback, useEffect, useState } from "react";
import { axios, errorResponse } from "../../helpers";

const usePendingTransactions = (token) => {
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const formatTransactions = useCallback((items) => {
    return items.map((transaction) => {
      // Get fabric_id from order_details
      const fabricId = transaction.order_details?.[0]?.fabric_id;
      // Find matching fabric from fabrics array
      const fabric = transaction.fabrics?.find((f) => f._id === fabricId);
      const fabricName = fabric?.fabric_name;

      const productName =
        fabricName ||
        (transaction.product_name?.length
          ? transaction.product_name.join(", ")
          : "N/A");

      return {
        id: transaction.order_id_midtrans,
        product: productName,
        date: new Date(transaction.createdAt).toLocaleDateString("id-ID"),
        orderStatus: transaction.statusOrder,
        paymentStatus: transaction.statusPayment,
        category:
          transaction.category?.length > 0
            ? transaction.category.join(", ")
            : "Custom",
        orderType: transaction.order_type || "Custom",
        total: new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
        }).format(transaction.total_amount),
        shipping:
          transaction.shipping_by || transaction.address?.city?.name || "N/A",
        image: "https://placehold.co/60x60/png",
        rawTotal: transaction.total_amount,
      };
    });
  }, []);

  const fetchPendingTransactions = useCallback(async () => {
    if (!token) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get("/v1/transactions/pending", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        setTransactions(formatTransactions(response.data.data));
        setError("");
      } else {
        setError(response.data.message || "Failed to fetch transactions");
      }
    } catch (error) {
      const msg = errorResponse(error) || "Error fetching transactions";
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  }, [token, formatTransactions]);

  useEffect(() => {
    fetchPendingTransactions();
  }, [fetchPendingTransactions]);

  return { transactions, isLoading, error, refetch: fetchPendingTransactions };
};

export default usePendingTransactions;
